<template>
  <div
    class="chat-banner-full bg-grey-500 py-8 w-full"
    :class="[chatStore.isChatStarted ? '' : 'hidden']"
  >
    <div class="chat-banner flex justify-end page-wrapper text-18">
      <button
        type="button"
        class="chat-banner__button bg-white-500 rounded-md h-40 flex items-center justify-center gap-8 px-16 cursor-pointer"
        @click="chatStore.ToggleChat()"
      >
        <div class="chat-banner__button__icon">
          <svg
            data-v-6ea70378=""
            data-v-867be6fe=""
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="stroke-width--small dynamic-icon"
          >
            <path
              data-v-6ea70378=""
              d="M16.3964 18.4142C16.7829 18.0391 17 17.4872 17 16.9568V10.5C17 9.96957 16.7829 9.46086 16.3964 9.08579C16.01 8.71071 15.5465 8.5 15 8.5H4C3.45348 8.5 2.99 8.71071 2.60355 9.08579C2.2171 9.46086 2 9.96957 2 10.5V16.9568C2 17.4568 2 18.9568 4 18.9568V22L8 18.9568H15C15.5465 18.9568 16.01 18.7893 16.3964 18.4142Z"
              stroke="#2A2A2B"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              data-v-6ea70378=""
              d="M7 8.5V5C7 4.46957 7.2171 3.96086 7.60355 3.58579C7.99 3.21071 8.51413 3 9.06065 3L19.9393 3C20.4859 3 21.01 3.21071 21.3964 3.58579C21.7829 3.96086 22 4.46957 22 5V11.5C22 12.9568 21 13.4568 20 13.5V16.5L17 14.4568"
              stroke="#2A2A2B"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </div>
        <div class="chat-banner__button__chat font-light">Aktiv chatt</div>
        <div class="chat-banner__button__badge border-l-2 border-blue-500 pl-8">
          <span
            class="bg-red-300 rounded-full h-18 w-18 px-6 py-3 text-white-500"
            >{{ chatStore.newMessageNumber }}</span
          >
        </div>
      </button>
    </div>
  </div>
  <div
    id="chatframe"
    class="chatframe absolute top-0 left-0 lg:top-56 lg:right-0 lg:left-auto w-full h-full lg:h-auto lg:w-auto"
    :class="{ hidden: !chatStore.isModalVisable }"
  ></div>
</template>

<script lang="ts" setup>
const chatStore = useMyChatStore();
const isHidden = ref(true);

const ChatInit = () => {
  const startedCookie = useCookie('a2be3m1chatstartedNKI');
  if (startedCookie.value) {
    chatStore.START_INTERVAL();
    return;
  }
};

onMounted(() => {
  document.addEventListener('chatOpened', () => {
    isHidden.value = false;
  });
  document.addEventListener('chatClose', () => {
    isHidden.value = true;
  });
  ChatInit();
});
</script>

<style scoped lang="scss"></style>
